export default __webpack_public_path__ + "static/media/notif.0decac26.svg";